<div class="flex" style="margin-top: 15px;" *ngIf="measurements && measurements.length > 0 && !loadingMeasurements">
  <div class="card w-full">
    <div class="p-datatable p-component p-datatable-hoverable-rows">
      <div class="grid p-datatable-header">
        <div class="col-6 md:col-6 xl:col-6">
          <div class="justify-content-start">
            <span class="p-input-icon-left ml-auto">
              <i class="pi pi-search"></i>
              <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')" [placeholder]="'search.bySensor' | transloco" />
            </span>
          </div>
        </div>
        <div class="col-6 md:col-6 xl:col-6">
          <div class="flex justify-content-end">
            <p-toggleButton
              [(ngModel)]="activeButtonState"
              [disabled]="selectedMeasurements.length == 0"
              [onLabel]="'misc.displayInAsset' | transloco"
              [offLabel]="'misc.hideInAsset' | transloco"
              (click)="changeDisplayInAsset()"
              class="ml-2"
              onIcon="pi pi-check"
              offIcon="pi pi-times"
            ></p-toggleButton>
          </div>
        </div>
      </div>
      <p-table #dt1
        [(selection)]="selectedMeasurements"
        [(first)]="first"
        [(rows)]="rows"
        [value]="measurements"
        [totalRecords]="totalMeasurements"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [paginator]="true"
        [globalFilterFields]="['name', 'description', 'alias', 'sensorType']"
        [rowsPerPageOptions]="[10,25,50]"
        styleClass="p-datatable-striped"
        sortField="name"
        dataKey="uuid"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="selection-column-width"></th>
            <th class="w-18rem" pSortableColumn="name">
              {{'attribute.name' | transloco}}<p-sortIcon field="name"></p-sortIcon></th>
            <th pSortableColumn="uuid">
              {{'attribute.uuid' | transloco}}<p-sortIcon field="uuid"></p-sortIcon></th>
            <th pSortableColumn="description">
              {{'attribute.description' | transloco}}<p-sortIcon field="description"></p-sortIcon></th>
            <th pSortableColumn="alias">
              {{'attribute.alias' | transloco}}<p-sortIcon field="alias"></p-sortIcon></th>
            <th pSortableColumn="measurementType.sensor">
              {{'model.sensorType' | transloco}}<p-sortIcon field="measurementType.sensor"></p-sortIcon></th>
            <th pSortableColumn="sampleRate">
              {{'attribute.sampleRate' | transloco}}<p-sortIcon field="sampleRate"></p-sortIcon></th>
            <th pSortableColumn="sampleRate">
              {{'attribute.expression' | transloco}}<p-sortIcon field="expression"></p-sortIcon></th>
            <th pSortableColumn="dateLastValueReported">
              {{'attribute.dateLastValueReported' | transloco}}<p-sortIcon field="dateLastValueReported"></p-sortIcon></th>
            <th pSortableColumn="lastValueReported">
              {{'attribute.lastValueReported' | transloco}}<p-sortIcon field="lastValueReported"></p-sortIcon></th>
            <th pSortableColumn="displayInAsset">
              {{'attribute.displayInAsset' | transloco}}<p-sortIcon field="displayInAsset"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-measurement>
          <tr *ngIf="!loadingMeasurements">
            <td>
              <span class="p-column-title bold">{{'common.select' | transloco}}</span>
              <p-tableCheckbox (click)="evaluateActiveButtonState()" [value]="measurement"></p-tableCheckbox>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
              <p class="text-right md:text-left" style="word-break: break-all;">{{measurement.name}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.uuid' | transloco}}</span>
              <p class="text-right md:text-left">
                <app-clipboard-label [value]="measurement.uuid" [copiedValue]="measurement.uuid"></app-clipboard-label>
              </p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
              {{measurement.description}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.alias' | transloco}}</span>
              {{measurement.alias}}
            </td>
            <td>
              <span class="p-column-title bold">{{'model.sensorType' | transloco}}</span>
              {{measurement.measurementType?.sensor ?? ''}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.sampleRate' | transloco}}</span>
              {{measurement.sampleRate}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.expression' | transloco}}</span>
              {{measurement.expression}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.dateLastValueReported' | transloco}}</span>
              <p class="text-right md:text-left">{{measurement.dateLastValueReported | customDate}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.lastValueReported' | transloco}}</span>
              {{measurement.lastValueReported}}
              <span *ngIf="measurement.lastValueReported && measurement.measurementType?.unit">{{measurement.measurementType.unit}}</span>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.displayInAsset' | transloco}}</span>
              <button
                *ngIf="measurement.displayInAsset"
                [label]="'common.yes' | transloco"
                (click)="changeIndividualDisplayInAsset(measurement)"
                pButton
                class="p-button-text cursor-pointer display-in-asset-success"
                iconPos="left"
                icon="pi pi-eye"
              ></button>
              <button
                *ngIf="!measurement.displayInAsset"
                [label]="'common.no' | transloco"
                (click)="changeIndividualDisplayInAsset(measurement)"
                pButton
                class="p-button-text cursor-pointer display-in-asset-danger"
                icon="pi pi-eye-slash"
                iconPos="left"
              ></button>
            </td>
          </tr>
          <tr *ngIf="loadingMeasurements">
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between" *ngIf="totalMeasurements == 0">
            {{'pagination.empty' | transloco}}
          </div>
          <div class="flex align-items-center justify-content-between" *ngIf="totalMeasurements > 0">
            {{'pagination.showing' | transloco}} {{first+1}}
            {{'pagination.to' | transloco}} {{(first+rows) >= totalMeasurements ? totalMeasurements : (first+rows)}}
            {{'pagination.of' | transloco}} {{totalMeasurements}}
            {{(totalMeasurements > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
          </div>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="measurements && measurements.length == 0">
  <div class="card w-full"><p class="text-xl text-center p-6 font-italic">{{'empty.sensors' | transloco}}</p></div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="!measurements || loadingMeasurements">
  <div class="card w-full">
    <app-table-skeleton [rows]="14"></app-table-skeleton>
  </div>
</div>
